import { hasSection } from '../utils';
import { Heading } from '@chakra-ui/react';
import React from 'react';

const RSFlat = ({ myData, props, previews, savedResume, styles, children,sectionName }) => {

  if (!hasSection(props, sectionName)) {
    return null;
  }
  const sectionObj = previews[sectionName];
  const label = sectionObj.label;
  return (

    <>
      <Heading sx={{ ...styles.sectionTitle }}>{label}</Heading>
      {children}
    </>
  );
};
export default RSFlat;